import React from 'react';
import { Modal, Tooltip } from 'antd';
import masterRateSheet from "../../../assets/images/masterLevelAccessorial.png";
import accLevel from "../../../assets/images/accLevelAccessorial.png";
import rateSheetAccessorialIcon from "../../../assets/images/rateSheetAccessorialIcon.png";
import I18n from '../../common/I18n';

export const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  
export const validateEmailList = (value) => {
  const validEmails = value.map(email => email.trim()).filter(isValidEmail);
  const invalidEmails = value.map(email => email.trim()).filter(email => !isValidEmail(email));

    if (invalidEmails.length) {
      Modal.error({
        title: 'Invalid Email Addresses Detected',
        content: (
            <ul>
              {invalidEmails.map((email, index) => (
                <li key={index}>{email}</li>
              ))}
            </ul>
        ),
        okText: 'OK',
      });
    }

  return validEmails;
};


export const ACCESSORIAL_INLINE_TAG_STYLE = { fontSize: '15px', color: '#0f85e8' };

export const isWarehouseOperationAccessorial = (record) =>
  record?.accessorial_config_params?.warehouse_operation === 'true';

export const isOrderLevelAccessorial = (record) =>
  record?.accessorial_config_params?.order_level_accessorials === 'true';

export const renderWarehouseOperationLabel = (record, options = {}) => {
  if (!isWarehouseOperationAccessorial(record)) {
    return null;
  }

  const { requiredAccessorials = [], showRequired = false } = options;

  return (
    <span style={ACCESSORIAL_INLINE_TAG_STYLE}>
      &nbsp;&nbsp;&ndash;&nbsp; {I18n.t('general.warehouse')} Operation{' '}
      {showRequired &&
        record?.accessorial_code &&
        requiredAccessorials.includes(record.accessorial_code) && (
          <sup className="textRed">*</sup>
        )}
    </span>
  );
};

export const renderOrderLevelAccessorialLabel = (record, style = {}) => {
  if (!isOrderLevelAccessorial(record)) {
    return null;
  }

  return (
    <span style={{ ...ACCESSORIAL_INLINE_TAG_STYLE, ...style }}>
      &nbsp;&nbsp;&ndash;&nbsp; {I18n.t('accessorials.order_level_accessorials')}{' '}
    </span>
  );
};

export const renderAccessorialConfigLabels = (record, options = {}) => (
  <>
    {renderWarehouseOperationLabel(record, options)}
    {renderOrderLevelAccessorialLabel(record, options.tagStyle)}
  </>
);

export const renderAcessorialIcon = (record, key, checkAccount = true ) => {  
  return (record[key] ? (
    <Tooltip title="Rate Sheet Accessorial">
      <img
        src={rateSheetAccessorialIcon}
        alt="Rate Sheet Accessorial"
        style={{
          width: '16px',
          height: '16px',
          marginRight: '3px',
          verticalAlign: 'middle',
          marginBottom: '3px'
        }}
      />
    </Tooltip>
  ) : !checkAccount || checkAccount && record.account_id ? (
    <Tooltip title="Account Accessorial">
      <img
        src={accLevel}
        alt="Account Accessorial"
        style={{
          width: '16px',
          height: '16px',
          marginRight: '3px',
          verticalAlign: 'middle',
          marginBottom: '3px'
        }}
      />
    </Tooltip>
  ) : null)

}